import React from 'react';
import { Link } from 'react-router-dom';

// react-router v4's Link isn't a forwardRef component; MUI needs the underlying <a>.
const RouterLink = React.forwardRef((props, ref) => <Link innerRef={ref} {...props} />);

export default RouterLink;
